import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

// Primary pill CTA — deep navy with hover fill
export const PrimaryButton = ({ children, to, href, onClick, className = "", testId, arrow = true, ...props }) => {
  const cls = `group relative inline-flex items-center gap-2 rounded-full bg-navy px-8 py-4 text-sm font-semibold uppercase tracking-[0.12em] text-white transition-colors duration-300 hover:bg-brand focus-visible:ring-2 focus-visible:ring-brand ${className}`;
  const inner = (
    <>
      <span>{children}</span>
      {arrow && (
        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      )}
    </>
  );
  if (to) return <Link to={to} data-testid={testId} className={cls} onClick={onClick} {...props}>{inner}</Link>;
  if (href) return <a href={href} data-testid={testId} className={cls} onClick={onClick} target={props.target} rel={props.rel}>{inner}</a>;
  return <button type={props.type || "button"} data-testid={testId} className={cls} onClick={onClick} {...props}>{inner}</button>;
};

// Secondary outline CTA
export const GhostButton = ({ children, to, href, onClick, className = "", testId, dark = false, ...props }) => {
  const tone = dark
    ? "border-white/25 text-white hover:bg-white hover:text-navy"
    : "border-navy/20 text-navy hover:bg-navy hover:text-white";
  const cls = `inline-flex items-center gap-2 rounded-full border px-8 py-4 text-sm font-semibold uppercase tracking-[0.12em] transition-colors duration-300 focus-visible:ring-2 focus-visible:ring-brand ${tone} ${className}`;
  if (to) return <Link to={to} data-testid={testId} className={cls} onClick={onClick} {...props}>{children}</Link>;
  if (href) return <a href={href} data-testid={testId} className={cls} onClick={onClick} target={props.target} rel={props.rel}>{children}</a>;
  return <button type={props.type || "button"} data-testid={testId} className={cls} onClick={onClick} {...props}>{children}</button>;
};

// Section eyebrow label
export const Eyebrow = ({ children, dark = false, className = "" }) => (
  <div className={`flex items-center gap-3 text-xs font-bold uppercase tracking-[0.24em] ${dark ? "text-brand-soft" : "text-brand"} ${className}`}>
    <span className={`h-px w-8 ${dark ? "bg-brand-soft" : "bg-brand"}`} />
    {children}
  </div>
);
